import { render, staticRenderFns } from "./MetricCell.vue?vue&type=template&id=1be43124&scoped=true&"
import script from "./MetricCell.vue?vue&type=script&lang=js&"
export * from "./MetricCell.vue?vue&type=script&lang=js&"
import style0 from "./MetricCell.vue?vue&type=style&index=0&id=1be43124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be43124",
  null
  
)

export default component.exports